module.exports = __webpack_public_path__ + "img/light-email.57c950d4.png";